import React from 'react'
import { Stack, Typography } from '@mui/material'
import i18n from 'simple-react-i18n'
import { RETURN_PERIOD_BANDS } from '../../../import/constants/IndicatorsConstants'
import { MAIN_RADIUS } from '../../../utils/constants/Theme'
import { grey, mediumGrey } from '../../../utils/constants/ColorTheme'

const SWATCH_STYLE = {
    width: '20px',
    height: '12px',
    borderRadius: MAIN_RADIUS,
}

const ReturnPeriodLegend = () => (
    <Stack direction='row' spacing={2} useFlexGap sx={{ flexWrap: 'wrap', alignItems: 'center', padding: '0 40px 10px 70px' }}>
        <Typography variant='caption' sx={{ color: mediumGrey, fontWeight: 'bold' }}>
            {`${i18n.returnPeriods} : `}
        </Typography>
        {RETURN_PERIOD_BANDS.map(({ code, color }) => (
            <Stack key={code} direction='row' spacing={0.5} sx={{ alignItems: 'center' }}>
                <div style={{ ...SWATCH_STYLE, backgroundColor: color }} />
                <Typography variant='caption'>{i18n[code]}</Typography>
            </Stack>
        ))}
        <Stack direction='row' spacing={0.5} sx={{ alignItems: 'center' }}>
            <div style={{ ...SWATCH_STYLE, height: 0, borderTop: `2px dashed ${grey}` }} />
            <Typography variant='caption'>{i18n.interannualMedian}</Typography>
        </Stack>
    </Stack>
)

export default ReturnPeriodLegend